import { createContext } from 'react';
import type { RoomsContextType } from './rooms-context-types';

export const RoomsContext = createContext<RoomsContextType | undefined>(undefined);